import { render, staticRenderFns } from "./FindPassword.vue?vue&type=template&id=6a5fcc9e&scoped=true&"
import script from "./FindPassword.vue?vue&type=script&lang=js&"
export * from "./FindPassword.vue?vue&type=script&lang=js&"
import style0 from "./FindPassword.vue?vue&type=style&index=0&id=6a5fcc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5fcc9e",
  null
  
)

export default component.exports